// 导航-->中英文
export const main = {
    'zhCN': {
        main: {
            mainLanguageSwitching: '语言切换',
            mainExitSystem: '退出系统',
            mainMasterDataManagement: '主数据管理',
            mainProductMasterData: '产品主数据',
            mainProduct: '产品基本信息',
            mainProductlevel: '产品线管理',
            mainProductanother: '产品别名',
            mainBatchimport: '批号导入',
            mainBatchlist: '批号管理',
            mainBatchanother: '批号别名',
            mainGeography: '地理信息管理',
            mainGeographycounty: '区县管理',
            mainGeographyCity: '城市管理',
            mainGeographyarea: '大区管理',
            mainPleaseSelect: '请先选择省份/城市/区县',
            mainNextStep: '请确认完整填写全部必填信息后再点击下一步',
            mainMaterialGroup: '分型查询',
            mainMaterialGroupCoefficient: 'VAT及补偿系数维护',
            mainMaterialGroupConversion: '分型间折算维护',
            simpleExpropriationCompensationUnitPrice: '简易征收补偿单价',
            commissionedImportCompensationDiscountUnitPrice: '委托进口折让单价',
            quarterCommissionedImport: '季度委托进口折让单价',
            // 系统管理
            mainSystemManagement: '系统管理',
            mainPersonne: '人员管理',
            mainCycleManagement: '周期管理',
            mainWorkdayMaintenance: '工作日管理',
            mainLogManagement: '日志管理',
            mainAnnouncementManagement: '公告管理',
            mainAnnouncementQuery: '公告管理',
            mainExceptionLogManagement: '异常日志管理',
            mainEventLogManagement: '事件日志管理',
            mainLoginLogManagement: '登录日志管理',
            mainAuthorityManagement: '权限设置',
            systemSetting: '系统设置',
            mainProductRightsGroupManagement: '产品权限组管理',
            mainReceiverType: '收货方类型管理',
            mainDictionaryManagement: '字典管理',
            mainInventoryReportSetup: '库存报表设置',
            mainRoleList: '角色管理',
            mainInvoicingSettings: '进销存设置',
            inventoryEstimateSetting: '经销商库存预估设置',
            mainOrderSetting: '订单设置',
            mainMaterialOrderSetting: '物料下单设置',
            mainContractSetting: '合同页脚设置',
            mainTenderingSetting: '招标设置',
            mainMilitaryAreaManagement: '军区管理',
            mainBiddingStateManagement: '招标状态管理',
            mainInventoryCheckDateFeedBackBaseline: '日库存差异反馈基线',
            mainDiscrepancyRateOfInventoryDaily: '日库存差异率设置',
            mainBaselineSettingOfTargetHospital: '目标医院销量基线',
            mainHomeSettings: '首页设置',
            mainDDIContributionRateSetting: 'DDI商业TMS占比',
            mainNoticeDefaultNumberSetting: '公告默认条数设置',
            mainOtherShipperSetting: '其他货主设置',
            mainNotificationSetting: '通知忽略设置',
            masterDataSettings: '主数据设置',
            mainTaskStatus: '服务运行状态',
            // 收货方主数据
            mainReceiver: '收货方主数据',
            mainReceiverManagement: '收货方管理',
            mainReceiverAnotherManagement: '收货方别名管理',
            mainReceiverLog: '收货方日志',
            mainQueryVolumeOfTargetHospital: '目标医院指标查询',
            mainHcoGapReport: '收货方差异报表',
            mainDrugstoreNearHospitalManagement: '医院周边药店',
            receiverAliasChangeRequestList: '别名变更申请查询',
            receiverAliasChangeRequest: '收货方别名申请',
            // 经销商主数据
            mainDistributor: '流向商业主数据',
            mainExpiringQualificationList: '临期资质',
            mainProductChannelList: '渠道管理',
            mainDistriButorList: '流向商业管理',
            applyList: '变更申请',
            mainMyApplyList: '我的审批',
            confirmList: '变更管理',
            contractorModal: '联系人管理',
            historyBillQuery: '历史单据查询',
            distributorProductQuery: '流向商业产品信息',
            distributorProductQueryByBO: '打单商业查询',

            // 流向管理
            mainSalesFlowManagement: '流向管理',
            mainImportData: '数据导入',
            mainSalesFlowConfirm: '流向数据确认',
            mainSalesFlowDistributorConfirm: '流向商业流向确认',
            mainAutoUpload: '自动日志列表',
            mainManualUpload: '上传日志列表',
            mainDeficiencyInspect: '流向差异性核查',
            mainDownload: '标准模板上传',
            mainDDIImportData: 'DDI数据导入',
            mainPurchaseQuery: '数据查询',
            otherQuery: '运行查询',
            abnormalTerminalReport: '异常终端报表',
            mainMonthlyPurchaseList: '月采购数据查询',
            mainDailyPurchaseList: '日采购数据查询',
            mainSalesFlowDailyStateList: '流向商业日提供情况',
            mainThirdPartyProcurementReport: '三方购进报表',
            mainDailySalesFlowQuery: '商务日流向查询',
            mainDailySalesFlowByTerminalQuery: '销售日流向查询',
            mainMonthlySalesFlowByTerminalQuery: '销售月流向查询',
            mainMonthlySalesFlowDistributorQuery: '商务月流向查询',
            mainDelistingProductSalesFlowQuery: '退市产品流向查询',
            mainMonthlySalesFlowDistributorSimpleQuery: '商务月流向精简查询',
            mainMonthlySalesFlowPreparatoryQuery: '可追溯商业流向查询',
            mainSalesFlowMonthlyStateList: '流向商业月提供情况',
            mainSalesFlowDelData: '数据删除',
            mainSalesFlowDelDataDailyStatus: '删除数据提供情况',
            mainSalesFlowDelDataMonthlyPurchase: '删除月采购数据',
            mainSalesFlowDelDataDailyPurchase: '删除日采购数据',
            mainSalesFlowDelDataDailyStock: '删除日库存',
            mainSalesFlowDelDataDailySalesFlow: '删除日流向',
            mainSalesflowInspect: '流向反馈',
            mainMonthlySAPData: 'SAP月数据生成',
            mainChannelAbnormalInspect: '渠道反馈',
            mainChannelAbnormalReason: '其他渠道记录',
            mainDataQuery: '数据查询',
            mainAnalepticQuery: '兴奋剂反馈',
            mainDefaultBatchModification: '默认批号修改',
            mainSuspectedTransfer: '疑似调拨反馈',
            mainTargetHospitalSales: '目标医院预警',
            mainDailySalesFlowSummaryQuery: '每日汇总报告',
            mainDTPDataManagement: 'DTP数据管理',
            mainDTPDataQuery: 'DTP数据查询',
            mainDTPDataImport: 'DTP数据导入',
            mainDTPDataImportLog: 'DTP上传日志',

            // 进销存管理
            mainInventory: '进销存管理',
            mainInventoryReport: '进销存报表',
            mainInventoryOtherItemReport: '进销存其它项汇总',
            mainDailyInventory: '日库存',
            mainDailyInventoryQuery: '日库存查询',
            mainInventoryInspect: '进销存反馈',
            mainDailyInventoryInspect: '日库存差异反馈',
            mainMonthlyInventoryInspect: '月进销货差异核查',
            mainDistributorAmountReport: '流向商业库存金额',
            mainBatchMonthlyInventory: '批号月库存查询',
            inventoryUpdateReport: '进销存更新报告',
            mainInventoryOverview: 'T1进销存进展',

            // 订单管理
            mainOrderManagement: '订单管理',
            mainProtocolManagement: '协议管理',
            mainShipperManagement: '货主管理',
            mainWarehouseManagement: '库房管理',
            mainShipperWarehouseProductManagement: '货主产品库房关联',
            mainCustomerAgreementManagement: '客户协议维护',
            mainPriceAgreementManagement: '产品价格维护',
            mainGXPBusinesscreditmaintenance: '客户资信查询',
            mainOrderProcessing: '订单处理',
            mainOrderProcess: '订单流程',
            mainContractConfirmation: '合同扫描确认',
            mainOrderDetailInquiry: '订单明细查询',
            mainBillMaintenance: '账单信息管理',
            mainAgreementNoticeManagement: '通知协议管理',
            mainAnotherName: '回款商业别名维护',
            mainPaymentBank: '回款信息查询',
            mainOrderQuery: '账单查询',
            mainDeliveryQuery: '物流查询',
            mainDeliveryDetail: '物流明细',
            mainShippingCalendar: 'Shipping Calendar',
            mainPartnerMamagement: '合作方管理',
            mainPartnerProductMamagement: '合作方客户产品关联',
            mainPartnerOrderMamagement: '合作方订单查询',
            mainPartnerBillMamagement: '合作方账单查询',

            // 销售计划
            salesPlan: '销售计划',
            salesPlanReport: '销售计划报表',
            mainachievingRateReport: '销售计划KPI报表',

            // 销售管理
            salesManagement: '销售管理',
            salesPlanImport: '销售计划管理',
            salesPlanManagement: '销售计划管理',
            salesPlanKPI: '销售计划KPI设置',
            salesPlanKPISummary: 'KPI汇总',
            salesCoefficientMaintenance: '销量系数维护',
            overallSalesPlan: '总发货计划维护',
            salesPlanDistributionReport: 'Proposal Simulator',

            // 报表管理
            mainReportManagement: '数据报表',
            mainSalesFlowReport: '流向报表',
            mainAnalysisByReceiverQuery: '按收货方汇总',
            mainAnalysisInMarketQuery: '月度TMS报表',
            mainAnalysisByReceiverProvince: '按收货方省份汇总',
            mainAnalysisInByDistributor: '按发货方汇总',
            analysisByDistributorAndReceiver: '发货方收货方汇总',
            compareByDistributor: '发货方对比报表',
            compareByReceiver: '收货方对比报表',
            splitDetailQuery: '拆分查询报表',
            dailySalesflowDifferenceReport: '日数据预警报表',
            salesFlowTMS: 'TMS报表',
            monthlyTMSByProvince: '月度TMS按省份汇总',
            // 销退管理
            mainSalesReturnManagement: '销退管理',
            mainSalesReturnOwner: '销退主导人',
            mainSalesReturnReason: '销退原因',
            mainSalesReturnReport: '销退报表',
            mainSalesReturnReply: '销退反馈',
            // 流向管理
            mainSalesFlowSetting: '流向设置',
            mainReplyRadixSetting: '反馈基数设置',
            salesReturnReplyRateLineSetting: '退货率基线设置',
            gXPBusinessInformationImport: 'GXP商业信息导入',
            gxpInfoTemplateDownload: 'GXP商业信息模板下载',
            productSettingOfSuspect: '疑似调拨品种设置',
            // 招标管理
            bidding: '招标管理',
            biddingProject: '项目管理',
            tenderPriceQuery: '价格查询',
            biddingDetailQuery: '明细查询',
            biddingEdit: '项目维护',
            projectManagement: '项目管理',
            biddingQueryForRepresentative: '外勤项目维护',
            biddingReport: '招标报表',
            biddingPriceConflict: '价格验证报表',
            biddingMonthRealPrice: '月度实际采购价报表',
            provinceMinPrice: '全国省级最低中标价',
            biddingOfDelistingProducts: '退市产品招标报表',
            processStepManagement: '流程步骤管理',
            defaultBidder: '默认投标主体管理',
            biddingTypeManagement: '招标类型管理',
            mainDrugStoreCompensationFile: '招标补偿支持件',
            mainCompensationSummaryList: '补偿单价管理',
            mainDrugStoreSetting: '药店补偿名单管理',
            documentManagement: '常用文档设置',
            confirmUnitPriceDetail: '确认补偿单价',
            compensationForBidding: '招标补偿',
            compensationBasicData: '补偿基础数据',
            compensationUnitPrice: '补偿单价',
            mainCertificate: '补偿证明',
            mainCertificateManagement: '补偿证明管理',
            mainReturnRequirement: '退货证明需求',
            certificateQuery: '补偿证明查询',
            mainCertificateDetailRepresentative: '付款渠道查询',
            dwCompensationSetting: 'D&W补偿名单管理',
            commissionedImportRule: '委托进口折让规则',
            // 云商管理
            weChatSettings: '云商设置',
            weChatNoticeSettings: '云商通知设置',
            customerManagement: '客户管理',
            billNoticeSetting: '账单提醒通知',
            weChatNoticeSettingDays: '账单提前X天通知设置',
            daysRateNotNull: '天数设置不能为空',
            settingDays: '设置天数',
            sendFeedBackNotice: '反馈提醒通知',
            customerNoticeManagement: '公告通知',
            compensationResult: '补偿结果',
            quarterCompensation: '季度补偿计算',
            accruedExpense: '月度预提',
            // 药店质量检查
            visitDrugstore: '药店质量检查',
            basicDataManagement: '基础数据维护',
            visitPlan: '检查计划',
            drugstoreManagement: '药店基础数据',
            drugstoreBUManagement: 'BU与药店基础数据',
            shippingModeManagement: '发货模式维护',
            visitResult: '检查结果',
            discountCategoryMaintenance: '折让分类维护'
        }
    },
    'enUS': {
        main: {
            mainLanguageSwitching: 'Language',
            mainExitSystem: 'Log Out',
            mainMasterDataManagement: 'Master data',
            mainProductMasterData: 'Product Management',
            mainProduct: 'Product',
            mainProductlevel: 'Product Line',
            mainProductanother: 'Product Alias',
            mainBatchimport: 'Import Batch Number',
            mainBatchlist: 'Batch Number',
            mainBatchanother: 'Batch Number Alias',
            mainGeography: 'Geographic',
            mainGeographycounty: 'County',
            mainGeographyCity: 'City',
            mainGeographyarea: 'Area',
            mainPleaseSelect: 'Please choose provinces and cities first.',
            mainNextStep: 'Please confirm that you have completed the required information and click on the next step',
            mainMaterialGroup: 'Material Group',
            mainMaterialGroupCoefficient: 'VAT And Compensation Coefficient',
            mainMaterialGroupConversion: 'Material Group Conversion',
            simpleExpropriationCompensationUnitPrice: 'Simple Expropriation Compensation Unit Price',
            commissionedImportCompensationDiscountUnitPrice: 'Commissioned Import Compensation Discount Unit Price',
            quarterCommissionedImport: 'Quarter Commissioned Import',

            // 系统管理
            mainSystemManagement: 'System',
            mainPersonne: 'Member',
            mainCycleManagement: 'Cycle Management',
            mainWorkdayMaintenance: 'Workday',
            mainLogManagement: 'Log Management',
            mainAnnouncementManagement: 'Announcement Management',
            mainAnnouncementQuery: 'AnnouncementManagement',
            mainExceptionLogManagement: 'Exception Log',
            mainEventLogManagement: 'Event Log',
            mainLoginLogManagement: 'Login Log',
            mainAuthorityManagement: 'Authority Setting',
            systemSetting: 'System Setting',
            mainProductRightsGroupManagement: 'Product Group',
            mainReceiverType: 'ReceiverTypeManagement',
            mainDictionaryManagement: 'Dictionary',
            mainInventoryReportSetup: 'Inventory Report Setting',
            mainRoleList: 'Role',
            mainInvoicingSettings: 'Invoicing Settings',
            inventoryEstimateSetting: 'Inventory Estimate Setting',
            mainOrderSetting: 'Order Setting',
            mainMaterialOrderSetting: 'Material Order Setting',
            mainContractSetting: 'Contract Setting',
            mainTenderingSetting: 'Tendering Setting',
            mainMilitaryAreaManagement: 'Military Area Management',
            mainBiddingStateManagement: 'Bidding State Management',
            mainInventoryCheckDateFeedBackBaseline: 'Inventory Checkdate FeedBack Baseline Setting',
            mainDiscrepancyRateOfInventoryDaily: 'Discrepancy Rate Of InventoryDaily',
            mainBaselineSettingOfTargetHospital: 'Baseline Setting Of TargetHospital',
            mainHomeSettings: 'Home Settings',
            mainDDIContributionRateSetting: 'DDI Contribution Rate Setting',
            mainNoticeDefaultNumberSetting: 'Notice Default Number Setting',
            mainOtherShipperSetting: 'Other Shipper Setting',
            mainNotificationSetting: 'Notification Ignorance Settings',
            masterDataSettings: 'MasterData Setting',
            mainTaskStatus: 'Service running status',
            // 收货方主数据
            mainReceiver: 'Receiver Management',
            mainReceiverManagement: 'Receiver',
            mainReceiverAnotherManagement: 'Receiver Alias',
            mainReceiverLog: 'Receiving Log',
            mainQueryVolumeOfTargetHospital: 'Query Volume Of TargetHospital',
            mainHcoGapReport: 'Ship-to party variance report',
            mainDrugstoreNearHospitalManagement: 'Nearby Hospital Drugstores',
            receiverAliasChangeRequestList: 'Receiver Alias Change Request',
            receiverAliasChangeRequest: 'Receiver Alias Change Request',
            // 经销商主数据
            mainDistributor: 'Distributor Management',
            mainExpiringQualificationList: 'Expired Qualification',
            mainProductChannelList: 'Product Channel',
            mainDistriButorList: 'Distributor',
            applyList: 'Approval Change',
            mainMyApplyList: 'My approval',
            confirmList: 'Confirm Change',
            contractorModal: 'Contact',
            historyBillQuery: 'Distributor Log',
            distributorProductQuery: 'Distributor Product',
            distributorProductQueryByBO: 'Distributor Product For BO',
            // 流向管理
            mainSalesFlowManagement: 'Sales Flow',
            mainImportData: 'Import Data',
            mainSalesFlowConfirm: 'Confirm',
            mainSalesFlowDistributorConfirm: 'Distributor Sales Flow',
            mainAutoUpload: 'Auto Upload Log',
            mainManualUpload: 'Upload Log',
            mainDownload: 'Standard Template',
            mainDDIImportData: 'Import DDI Data',
            mainPurchaseQuery: 'Query',
            otherQuery: 'Other Query',
            abnormalTerminalReport: 'Abnormal Terminal Report',
            mainMonthlyPurchaseList: 'Monthly Purchase',
            mainDailyPurchaseList: 'Daily Purchase',
            mainSalesFlowDailyStateList: 'Daily Status',
            mainThirdPartyProcurementReport: 'Third Party Procurement Report',
            mainDailySalesFlowQuery: 'Daily Flow',
            mainDailySalesFlowByTerminalQuery: 'DailyFlow By Terminal',
            mainMonthlySalesFlowByTerminalQuery: 'MonthlyFlow By Terminal',
            mainMonthlySalesFlowDistributorQuery: 'Distributor Sales Flow',
            mainDelistingProductSalesFlowQuery: 'Delisting Product Sales Flow',
            mainMonthlySalesFlowDistributorSimpleQuery: 'Distributor Simple Sales Flow',
            mainMonthlySalesFlowPreparatoryQuery: 'Preparatory Sales Flow',
            mainSalesFlowMonthlyStateList: 'Month Status',
            mainSalesFlowDelData: 'Delete',
            mainSalesFlowDelDataDailyStatus: 'Delete Daily Status',
            mainSalesFlowDelDataMonthlyPurchase: 'Delete Monthly Purchase',
            mainSalesFlowDelDataDailyPurchase: 'Delete Daily Purchase',
            mainSalesFlowDelDataDailyStock: 'Delete Daily Inventory',
            mainSalesFlowDelDataDailySalesFlow: 'Delete Daily Sales Flow',
            mainSalesflowInspect: 'SalesFlow FeedBack',
            mainDeficiencyInspect: 'Sales flow Deficiency',
            mainMonthlySAPData: 'SAP Monthly Data',
            mainChannelAbnormalInspect: 'ChannelFeedBack',
            mainChannelAbnormalReason: 'OtherChannelAbnormalFeedback',
            mainDataQuery: 'Query',
            mainAnalepticQuery: 'StimulantsFeedBack',
            mainDefaultBatchModification: 'Default Batch Number',
            mainSuspectedTransfer: 'Suspected allocation feedback',
            mainTargetHospitalSales: 'Target Hospital Sales',
            mainDailySalesFlowSummaryQuery: 'Daily Sales Flow Summary',
            mainDTPDataManagement: 'DTP Data Management',
            mainDTPDataQuery: 'DTP Data Query',
            mainDTPDataImport: 'DTP Data Import',

            // 进销存管理
            mainInventory: 'Inventory',
            mainInventoryReport: 'Report',
            mainInventoryOtherItemReport: 'OtherItem Report',
            mainDailyInventory: 'Daily Inventory',
            mainDailyInventoryQuery: 'Daily Inventory',
            mainInventoryInspect: 'Inventory FeedBack',
            mainDailyInventoryInspect: 'DailyInventoryFeedBack',
            mainMonthlyInventoryInspect: 'Monthly Sales Flow Inspect',
            mainDistributorAmountReport: 'Distributor Amount Report',
            mainBatchMonthlyInventory: 'Batch Monthly Inventory',
            inventoryUpdateReport: 'Inventory Update Report',
            mainInventoryOverview: 'T1 Inventory Overview',

            // 订单管理
            mainOrderManagement: 'Order',
            mainProtocolManagement: 'Agreement',
            mainShipperManagement: 'Shipper',
            mainWarehouseManagement: 'Warehouse Management',
            mainShipperWarehouseProductManagement: 'Owners product warehouse association',
            mainCustomerAgreementManagement: 'Customer Agreement',
            mainPriceAgreementManagement: 'Price Agreement',
            mainGXPBusinesscreditmaintenance: 'Customer credit inquiry',
            mainOrderProcessing: 'Order Processing',
            mainOrderProcess: 'OrderProcess',
            mainContractConfirmation: 'Contract Confirm',
            mainOrderDetailInquiry: 'Order Detail',
            mainBillMaintenance: 'Bill',
            mainAgreementNoticeManagement: 'Agreement Notice',
            mainAnotherName: 'Collection business alias maintenance',
            mainPaymentBank: 'Collection information query',
            mainDeliveryQuery: 'Delivery Query',
            mainDeliveryDetail: 'Delivery Detail',
            mainShippingCalendar: 'Shipping Calendar',
            mainPartnerMamagement: 'Partner Mamagement',
            mainPartnerProductMamagement: 'Partner Product Mamagement',
            mainPartnerOrderMamagement: 'Partner Order Mamagement',
            mainPartnerBillMamagement: 'Partner Bill Mamagement',

            // 销售计划
            salesPlan: 'Sales Plan',
            salesPlanReport: 'Sales plan report',
            mainachievingRateReport: 'Sales plan KPI report',

            // 销售管理
            salesManagement: 'Sales management',
            salesPlanImport: 'Import Sales plan',
            salesPlanManagement: 'Sales plan management',
            salesPlanKPI: 'Sales plan KPI settings',
            salesPlanKPISummary: 'KPI Summary',
            salesCoefficientMaintenance: 'Sales Factor',
            overallSalesPlan: 'Total EFS Plan',
            salesPlanDistributionReport: 'Proposal Simulator',

            // 报表管理
            mainReportManagement: 'data report',
            mainSalesFlowReport: 'Flow report',
            mainAnalysisByReceiverQuery: 'Summary by ship-to party',
            mainAnalysisInMarketQuery: 'Monthly TMS Report',
            mainAnalysisByReceiverProvince: 'Summary by the province of the receiving party',
            mainAnalysisInByDistributor: 'Summary by shipper',
            analysisByDistributorAndReceiver: 'Shippers receiver summary',
            compareByDistributor: 'Shipper comparison report',
            compareByReceiver: 'Consignee comparison report',
            splitDetailQuery: 'Split details report',
            dailySalesflowDifferenceReport: 'Daily Data Difference',
            salesFlowTMS: 'TMS Report',
            monthlyTMSByProvince: 'Monthly TMS by province report',

            // 销退管理
            mainSalesReturnManagement: 'SalesReturnManagement',
            mainSalesReturnOwner: 'SalesReturnOwner',
            mainSalesReturnReason: 'SalesReturnReason',
            mainSalesReturnReport: 'SalesReturnReport',
            mainSalesReturnReply: 'SalesReturnReply',
            // 流向管理
            mainSalesFlowSetting: 'SalesFlow Set Up',
            mainReplyRadixSetting: 'Feedback cardinality setting',
            salesReturnReplyRateLineSetting: 'Sales Return Reply RateLine Setting',
            gXPBusinessInformationImport: 'GXP Business Information Import',
            gxpInfoTemplateDownload: 'GXPInformation TemplateDownload',
            productSettingOfSuspect: 'Product Setting Of Suspect',

            // 招标管理
            bidding: 'Bidding',
            biddingProject: 'Bidding Project',
            tenderPriceQuery: 'Tender Price Query',
            biddingDetailQuery: 'Bidding Detail Query',
            biddingEdit: 'Bidding Edit',
            projectManagement: 'Project management',
            biddingReport: 'Bidding Report',
            biddingQueryForRepresentative: 'Bindding Query For Representative',
            biddingPriceConflict: 'Bidding Price Conflict',
            provinceMinPrice: 'Minimum Winning Bid Price At Provincial Level',
            biddingOfDelistingProducts: 'BiddingOfDelistingProducts',
            documentManagement: 'Document Management',
            confirmUnitPriceDetail: 'Confirm compensation unit price',
            compensationForBidding: 'Compensation for bidding',
            compensationBasicData: 'Compensation Basic Data',
            compensationUnitPrice: 'Compensation unit price',
            mainCertificate: 'Compensation Certificate',
            mainCertificateManagement: 'Compensation certificate management',
            mainReturnRequirement: 'Return proof requirements',
            processStepManagement: 'Process step management',
            defaultBidder: 'Default bidder management',
            biddingTypeManagement: 'Bidding Type Management',
            mainDrugStoreCompensationFile: 'Pharmacy compensation support',
            mainCompensationSummaryList: 'Compensation summary record query',
            mainDrugStoreSetting: 'Pharmacy compensation list maintenance',
            certificateQuery: 'Certificate Query',
            mainCertificateDetailRepresentative: 'Payment Channel Quer ',
            dwCompensationSetting: 'D&W compensation list maintenance',
            commissionedImportRule: 'Rule Of Commissioned Import',
            // 云商管理
            weChatSettings: 'WeChat Settings',
            weChatNoticeSettings: 'WeChat Notice Settings',
            customerManagement: 'Customer Management',
            billNoticeSetting: 'Bill Notice Setting',
            sendFeedBackNotice: 'FeedBack Notice',
            weChatNoticeSettingDays: 'Bills advance X-day notification settings',
            daysRateNotNull: 'Setting days cannot be empty',
            settingDays: 'Setting Days',
            customerNoticeManagement: 'Customer Notice',
            compensationResult: 'Compensation Result',
            quarterCompensation: 'Quarter Compensation Calculation',
            accruedExpense: 'Accrued Expense',
            // 药店拜访
            visitDrugstore: 'Visit Drugstore',
            basicDataManagement: 'Basic Data Management',
            visitPlan: 'Visit Plan',
            drugstoreManagement: 'Drugstore Management',
            drugstoreBUManagement: 'Drugstore and BU Management',
            shippingModeManagement: 'Shipping Mode Management',
            visitResult: 'Visit Result',
            discountCategoryMaintenance: 'Discount Category Maintenance',
        }
    }
}
export default main



// WEBPACK FOOTER //
// ./src/locale/modules/main.js